import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { ServerPassword } from './views/ServerPassword';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<ServerPassword />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.ServerPassword)
	.build();

export default Layout;
